import { scales } from './constants';

export const lg = (value: number) => value * scales.laptop;
export const xl = (value: number) => value * scales.desktop;
